import React from 'react';
import {Form, Formik, FormikHelpers} from 'formik';
import styled from 'styled-components';
import {useTranslations} from "use-intl";

import {CallFormPayload, sendCallForm} from '@/services/requests';
import {TextInputFormik} from '@/components/TextInput';
import Button from '@/components/Button';
import {areAllErrorsVisible, validatePhone,} from '@/components/TextInput/formikHelpers/form.helpers';
import UseModalsOpen from '@/hooks/useModalsOpen';
import {TFunction} from "@/typings/common";

function validate(t:TFunction, {phone, name}: CallFormPayload) {
  const errors: Partial<CallFormPayload> = {};
  if (!validatePhone(phone)) {
    errors.phone = t('forms.phone_error');
  }
  if (!phone) {
    errors.phone = t('forms.required');
  }
  if (!name) {
    errors.name = t('forms.required');
  }
  return errors;
}

const hasFrontendValidationErrors = (t:TFunction, values: CallFormPayload) =>
  !!Object.keys(validate(t, values)).length;

function CallbackFormRequest({setFormClosed}: { setFormClosed: () => void }) {
  const {closeModalState} = UseModalsOpen();

  const t = useTranslations();


  function handleSubmit(
    values: CallFormPayload,
    formikHelpers: FormikHelpers<CallFormPayload>
  ) {
    return sendCallForm(values)
      .then(() => {
        setFormClosed();
        closeModalState();
        formikHelpers.setSubmitting(true);
      })
      .catch(() => {
        formikHelpers.setErrors({
          phone: t('forms.unknown_error'),
        });
        formikHelpers.setStatus({
          hasBackendError: true,
        });
      })
      .finally(() => {
        formikHelpers.setSubmitting(false);
      });
  }


  return (
    <Body>
      <Text>{t('leave_contacts')}</Text>
      <Formik<CallFormPayload>
        initialValues={{name: '', phone: ''}}
        onSubmit={handleSubmit}
        validate={fields => validate(t, fields)}
      >
        {({isSubmitting, isValid, values, dirty, ...props}) => (
          <Form>
            <FormRow>
              <TextInputFormik
                name="name"
                icon="profile"
                placeholder={t('forms.name')}
                autoComplete="off"
                invalid={false}
              />
            </FormRow>
            <FormRow>
              <TextInputFormik
                name="phone"
                icon="phone"
                placeholder={t('forms.phone')}
                autoComplete="off"
                invalid={false}
              />
            </FormRow>
            <Button
              type="submit"
              variant="contained-primary-w100-f13"
              disabled={
                !(isValid || !hasFrontendValidationErrors(t, values)) &&
                areAllErrorsVisible(props.errors, props.touched)
              }
              children={t('forms.send')}
              loading={isSubmitting}
            />
          </Form>
        )}
      </Formik>
    </Body>
  );
}

export default CallbackFormRequest;

const Text = styled.div`
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 20px;
`;

const FormRow = styled.div`
  margin-bottom: 30px;
`;

const Body = styled.div`
  margin-top: 20px;
  padding: 0 15px;
`;
